import { InvoiceStatus, As400TransactionSyncStatus as SyncStatus } from "@/graphql/codegen/graphql"

export const AS400_SYNC_PENDING_TOOLTIP = "Pending sync to AS400."

export const AS400_SYNC_FAILED_TOOLTIP = "AS400 Sync Failed"

export const AS400_SYNC_RESOLVED_TOOLTIP = "Sync exception manually reconciled. View comments for details."

// AK-5232 AC3: the two screens tell the user how to recover from a failed approval sync.
export const AS400_APPROVAL_SYNC_FAILED_TOOLTIP = "AS400 sync failed. Edit and resubmit, or resubmit without changes."

export const AS400_PAYABLE_APPROVAL_SYNC_FAILED_TOOLTIP = "AS400 sync failed. Approve again to retry."

// AK-5383 AC2/AC3, AK-5648 AC2/AC3, AK-5649 AC2/AC3/AC4/AC5: the tooltip of the sync an invoice status depends on.
// Approved is not here: while its approval sync runs the status only reads "Pending AS400 Sync" (AK-5232 AC2).
export const INVOICE_STATUS_TO_AS400_SYNC_TOOLTIP: Partial<
  Record<InvoiceStatus, Partial<Record<SyncStatus.InProgress | SyncStatus.Failed, string>>>
> = {
  [InvoiceStatus.Paid]: {
    [SyncStatus.InProgress]: "Payment completed in AEROS. AS400 sync is in progress.",
    [SyncStatus.Failed]: "AS400 sync failed. Manually update the payment in AS400, then confirm manual reconciliation.",
  },
  [InvoiceStatus.Voided]: {
    [SyncStatus.InProgress]: "Invoice voided in AEROS. AS400 sync is in progress.",
    [SyncStatus.Failed]: "AS400 sync failed. Manually void the payment in AS400, then confirm manual reconciliation.",
  },
  [InvoiceStatus.Cancelled]: {
    [SyncStatus.InProgress]: "The invoice was cancelled in AEROS. AS400 sync is in progress.",
    [SyncStatus.Failed]: "AS400 sync failed. Manually cancel the invoice in AS400, then confirm manual reconciliation.",
  },
  [InvoiceStatus.PendingApproval]: {
    [SyncStatus.InProgress]: "The invoice was resubmitted for approval in AEROS. AS400 reversal is in progress.",
    [SyncStatus.Failed]: "AS400 sync failed. Changes updated only in AEROS. Manually reverse in AS400.",
  },
}

// AK-5648 AC4: the void was AEROS-only because the original payment never reached AS400.
export const AS400_VOID_SKIPPED_TOOLTIP =
  "AEROS void completed. AS400 sync skipped. Manual AS400 reconciliation required."

export const AS400_VOID_SKIPPED_AFTER_RESOLVED_TOOLTIP = "Manual AS400 action required."

export const AS400_VOID_SKIPPED_WARNING =
  "The original payment was not successfully synchronized with AS400. This invoice will be voided in AEROS only, and no AS400 reconciliation event will be sent. Review AS400 and manually complete any required void, reversal, or open-payable adjustment."

export const AS400_APPROVAL_SYNC_PENDING_LABEL = "Pending AS400 Sync"

// AK-6358 AC2: the confirmation shown before a sync exception is marked as manually reconciled.
export const AS400_RECONCILIATION_MESSAGE =
  "Confirm that the corresponding record has been manually updated in AS400 to match AEROS. Add a comment, then click Mark as Resolved to acknowledge that this sync exception has been manually reconciled."

// AK-5648 AC2/AC3: for a failed void the confirmation names the void.
export const AS400_VOID_RECONCILIATION_MESSAGE =
  "Confirm that the void has already been completed manually in AS400. Add a comment, then click Mark as Resolved to acknowledge that this sync exception has been manually reconciled."
